(() => {
  if (window.__qrAudienceCarouselInit) return;
  window.__qrAudienceCarouselInit = true;

  // 100vw resolves to the true browser viewport width, but Horizon renders
  // page content inside its own scrollable ".page-wrapper" div (html/body
  // are locked with overflow: hidden and that wrapper scrolls instead). That
  // wrapper reserves its own scrollbar gutter, which shrinks the content
  // area sections actually render into without shrinking 100vw — so the
  // classic "100vw full-bleed" trick lands a few pixels too far left.
  // Measure the real gap directly against .page-wrapper (falling back to
  // documentElement for other themes/contexts) and expose it as a CSS
  // custom property the bleed calc()s can subtract out.
  const setScrollbarWidthVar = () => {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:fixed; top:-9999px; left:0; width:100vw; height:1px; visibility:hidden; pointer-events:none;';
    document.body.appendChild(probe);
    const vwWidth = probe.getBoundingClientRect().width;
    probe.remove();
    const contentContainer = document.querySelector('.page-wrapper') || document.documentElement;
    const gap = Math.max(vwWidth - contentContainer.clientWidth, 0);
    document.documentElement.style.setProperty('--qr-sbw', gap + 'px');
  };
  setScrollbarWidthVar();
  window.addEventListener('resize', setScrollbarWidthVar);

  const initCarousel = (root) => {
    const scope = root || document;
    scope.querySelectorAll('.audience-carousel:not([data-carousel-ready])').forEach((section) => {
      section.dataset.carouselReady = 'true';

      const track = section.querySelector('[data-carousel-track]');
      const header = section.querySelector('.audience-carousel__header');
      const prevBtn = section.querySelector('[data-carousel-prev]');
      const nextBtn = section.querySelector('[data-carousel-next]');
      const cards = Array.from(section.querySelectorAll('.audience-carousel__card'));
      if (!track || !cards.length) return;

      // Align the first card with the heading above it (the page's real
      // left content margin) rather than guessing it from CSS.
      const updateInset = () => {
        if (!header) return;
        const inset = Math.max(header.getBoundingClientRect().left, 0);
        track.style.setProperty('--qr-carousel-inset', inset + 'px');
      };
      updateInset();
      window.addEventListener('resize', updateInset);

      const step = () => {
        const card = cards[0];
        const trackStyle = getComputedStyle(track);
        const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        // scroll-padding-left makes the browser treat the inset as the true
        // edge, so the resting "start" position is scrollLeft 0 again.
        const max = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft >= max - 2;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = max <= 0 || atEnd;
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateNav();
          ticking = false;
        });
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      updateNav();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initCarousel());
  document.addEventListener('shopify:section:load', (event) => initCarousel(event.target));

  if (document.readyState !== 'loading') {
    initCarousel();
  }
})();
